export class User {
    id: number;
    email: string;
    firstname: string;
    lastname: string;
    mapId: number;
    password: string;
    priviledgeId: number;
    priviledgeName: string;
    token: string;
    tokenExpires: any;
    username: string;
    userType: any;
    userTypeId: any;
}